import React from 'react';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './HomepageTopics.scss';

const HomepageTopics = () => {
  return (
    <div className="HomepageTopics">
      <div className="HomepageTopics__container">
        <ul className="HomepageTopics__items">
          <li className="HomepageTopics__item HomepageTopics__item--educators">
            <h5 className="HomepageTopics__item-subheader">
              <ConnectedFormattedMessage id="product_benefits.educators.title" />
            </h5>
            <p className="HomepageTopics__item-paragraph">
              <ConnectedFormattedMessage id="product_benefits.educators.description" />
            </p>
          </li>
          {/*  <li className="HomepageTopics__item HomepageTopics__item--data">
            <h5 className="HomepageTopics__item-subheader">
              <ConnectedFormattedMessage id="product_benefits.data.title" />
            </h5>
            <p className="HomepageTopics__item-paragraph">
              <ConnectedFormattedMessage id="product_benefits.data.description" />
            </p>
          </li> */}
          <li className="HomepageTopics__item HomepageTopics__item--learning">
            <h5 className="HomepageTopics__item-subheader">
              <ConnectedFormattedMessage id="product_benefits.learning.title" />
            </h5>
            <p className="HomepageTopics__item-paragraph">
              <ConnectedFormattedMessage id="product_benefits.learning.description" />
            </p>
          </li>
          <li className="HomepageTopics__item HomepageTopics__item--support">
            <h5 className="HomepageTopics__item-subheader">
              <ConnectedFormattedMessage id="product_benefits.support.title" />
            </h5>
            <p className="HomepageTopics__item-paragraph">
              <ConnectedFormattedMessage id="product_benefits.support.description" />
            </p>
          </li>
        </ul>
        <div className="HomepageTopics__infographic">
          <div className="HomepageTopics__infographic-copy">
            <ConnectedFormattedMessage
              id="product_benefits.reach"
              containsHtml
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageTopics;
